import type { NextResponse } from 'next/server';

export const GOOGLE_CREDENTIAL_TRACKING_COOKIE = 'hp_google_credential_received';

const FIVE_MINUTES_SECONDS = 300;

export function markGoogleCredentialReceived(response: NextResponse): void {
  response.cookies.set(GOOGLE_CREDENTIAL_TRACKING_COOKIE, '1', {
    httpOnly: false,
    secure: true,
    sameSite: 'lax',
    path: '/',
    maxAge: FIVE_MINUTES_SECONDS,
  });
}

export function consumeGoogleCredentialMarker(): boolean {
  if (typeof document === 'undefined') return false;

  const marker = document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(`${GOOGLE_CREDENTIAL_TRACKING_COOKIE}=`));

  if (!marker) return false;

  document.cookie = `${GOOGLE_CREDENTIAL_TRACKING_COOKIE}=; max-age=0; path=/; SameSite=Lax`;
  return marker === `${GOOGLE_CREDENTIAL_TRACKING_COOKIE}=1`;
}
